import { LuPrinter } from "react-icons/lu";
import CvSidebar from "./CvSidebar";
import SectionTitle from "./SectionTitle";
import ExperienceItem from "./ExperienceItem";
import ProjectItem from "./ProjectItem";
import EducationItem from "./EducationItem";
import RichText from "./RichText";
import {
  profile,
  profileText,
  experience,
  featuredProject,
  education,
  educationNote,
} from "../../data/cvData";
import "./CvPage.css";

// Página de CV en formato A4 (dos columnas), imprimible / exportable a PDF.
// Todos los estilos viven bajo `.cv-root` para no afectar al resto de la app.
export default function CvPage() {
  return (
    <div className="cv-root">
      <button
        type="button"
        className="cv-print-btn cv-no-print"
        onClick={() => window.print()}
      >
        <LuPrinter aria-hidden="true" size={16} />
        Imprimir / Guardar PDF
      </button>

      <div className="cv-sheet">
        <CvSidebar />

        <main className="cv-main">
          <header className="cv-header">
            <h1 className="cv-name">{profile.name}</h1>
            <p className="cv-role">{profile.title}</p>
          </header>

          <section className="cv-block">
            <SectionTitle>Perfil Profesional</SectionTitle>
            <p className="cv-profile-text">
              <RichText text={profileText} />
            </p>
          </section>

          <section className="cv-block">
            <SectionTitle>Experiencia Laboral</SectionTitle>
            {/* Datos en orden cronológico: se invierten para mostrar la más
                reciente primero. `slice()` evita mutar el arreglo importado. */}
            {experience.slice().reverse().map((e) => (
              <ExperienceItem key={e.company} {...e} />
            ))}
          </section>

          <section className="cv-block">
            <SectionTitle>Proyecto Destacado</SectionTitle>
            <ProjectItem {...featuredProject} />
          </section>

          <section className="cv-block">
            <SectionTitle>Formación Académica</SectionTitle>
            {/* Igual que la experiencia: datos cronológicos, se muestran al revés. */}
            {education.slice().reverse().map((ed) => (
              <EducationItem key={ed.title} {...ed} />
            ))}
            {educationNote ? <p className="cv-edu-note">{educationNote}</p> : null}
          </section>
        </main>
      </div>
    </div>
  );
}
